// Ortak — personel çekmecesinin etiket satırındaki "Düzenle" (#29). `ghost` + `Pencil`: EP'nin diğer
// "bu kaydı düzenle" düğmeleri (`ContractorDetailPage`, `PermitDetailPage`, `RiskAssessmentDetailPage`)
// böyledir ve çekmecenin asıl işi olan "Belge yükle"ye (secondary) kaybetmelidir. `editButtonRef`
// kaydet / onaylı vazgeç sonrası odağın döndüğü yerdir.
//
// `loading` (EP izin çekmecesi, kişi kaydı yüklenirken): hedef henüz yok → düğme devre dışı, `Pencil`
// yerine `Loader2` (hareket azaltılmışsa dönmez), durum yalnız ekran okuyucuya metin olarak.
import { Loader2, Pencil } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/Button';
import type { PersonnelEditTarget } from './personnelEdit';
import type { PersonnelEditor } from './usePersonnelEditor';

export type PersonnelEditButtonProps =
  | { editor: PersonnelEditor; target: PersonnelEditTarget; loading?: false }
  | { editor: PersonnelEditor; target?: undefined; loading: true };

export function PersonnelEditButton(props: PersonnelEditButtonProps) {
  const { t } = useTranslation();
  const { editor, target } = props;
  const loading = props.loading === true;
  return (
    <Button
      ref={editor.editButtonRef}
      type="button"
      variant="ghost"
      size="sm"
      loading={loading}
      onClick={() => {
        if (target) {
          editor.begin(target);
        }
      }}
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin motion-reduce:animate-none" aria-hidden="true" />
      ) : (
        <Pencil className="h-4 w-4" aria-hidden="true" />
      )}
      {t('personnelForm.edit.action')}
      {loading ? <span className="sr-only">{t('personnelForm.hydrate.loading')}</span> : null}
    </Button>
  );
}
